import { CheckoutInput } from "../../../../api/backend/backend-api"
import { DEFAULT_MAX_SELL_QUANTITY } from "../../parameters"
import { BasketItem } from "../checkoutTypes"
import { basketUpdate } from "./basketUpdate"

const transform = (
  input: ChangeQuantityInput,
  checkout: CheckoutInput
): CheckoutInput => {
  const variantsToUpdate = checkout.lineItems.filter(
    (x) => x.variantId === input.item.variant?.info.variantId
  )
  variantsToUpdate.forEach(
    (x) =>
      (x.quantity = Math.min(
        input.item.variant?.inventory?.maxSellQuantity ??
          DEFAULT_MAX_SELL_QUANTITY,
        input.newQuantity
      ))
  )
  return checkout
}

export interface ChangeQuantityInput {
  item: BasketItem
  newQuantity: number
}

export const changeQuantity = (
  input: ChangeQuantityInput,
  callback?: () => void,
  errorCallback?: (error: any) => void
) => {
  return basketUpdate({
    input: (checkout) => transform(input, checkout),
    callback,
    errorCallback,
  })
}
